<template>
  <div class="content-container">
    <search-comp>
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Nhóm mẫu</div>
                <div>
                  <el-select
                    v-model="searchParams.templateGroup"
                    @change="changeTemplateGroup(data)"
                  >
                    <el-option
                      v-for="option in templateGroups"
                      :key="option.id"
                      :value="option.id"
                      :label="option.desc"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Loại mẫu</div>
                <div>
                  <el-select v-model="searchParams.templateType">
                    <el-option
                      v-for="option in typeGroups"
                      :key="option.id"
                      :value="option.id"
                      :label="option.desc"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <el-row class="grid-scroll" :gutter="10">
      <el-col :xs="24" :sm="10" :md="10" :lg="10"
        ><div class="grid-content">
          <!-- <ConfigModelSearch @onSearch="onSearch" /> -->
          <div
            class="grid-scroll table-container"
            style="height: calc(70vh - 180px)"
          >
            <GridVx
              ref="agGrid"
              :context="context"
              :columns="columns"
              :auto-size-cell="true"
              :rows="rows"
              dom-layout="scroll"
              class="agGrid"
              @rowClicked="onRowClicked"
            />
          </div></div
      ></el-col>
      <el-col :xs="24" :sm="14" :md="14" :lg="14">
        <div id="template-render-container">
          <div id="template-render-section" class="grid-content bg-white" />
        </div>
      </el-col>
    </el-row>
    <div class="button-containers mb-0">
      <button class="btn primary small outline" @click="deleteTemplate">
        {{ $t('button.delete') }}
      </button>
      <button class="btn primary small" @click="addModel">
        {{ $t('button.add') }}
      </button>
      <!-- <button class="btn primary small outline" @click="alert('sao chep mau')">
        Sao chép mẫu
      </button> -->
      <button class="btn primary small" @click="modifyModel">
        {{ $t('button.modify') }}
      </button>

      <!-- <button class="btn primary small" @click="onUpTemplate">Lên</button> -->
      <!-- <button class="btn primary small outline" @click="onDownTemplate">
        Xuống
      </button> -->
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="Thêm mẫu"
      width="1400px"
      :close-on-click-modal="false"
    >
      <div class="das-layout mb-10 gap-20">
        <div class="l-w-70 column gap-10" style="gap: 10px">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">Tên mẫu</div>
                    <input
                      v-model="data.name"
                      type="text"
                      placeholder="Nhập tên mẫu"
                    />
                  </div>
                </div>
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">Khổ giấy</div>
                    <el-select v-model="data.paperSize" placeholder="">
                      <el-option
                        v-for="option in paperSizeList"
                        :key="option.id"
                        :value="option.id"
                        :label="option.code"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">Bố cục</div>
                    <el-select v-model="data.layout" placeholder="">
                      <el-option
                        v-for="option in layoutList"
                        :key="option.value"
                        :value="option.value"
                        :label="option.label"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ckeditor
            ref="ckeditor"
            v-model="editorData"
            :editor="editor"
            :config="editorConfig"
            @ready="onEditorReady"
          />
        </div>
        <div class="l-w-30 column" style="gap: 10px">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-12">
                  <div class="das-form-input">
                    <div class="label">Tham số</div>
                    <input
                      v-model="data.name"
                      type="text"
                      placeholder="Nhập thông tin cần tìm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-scroll" style="height: 600px">
            <GridVx
              ref="agGrid2"
              dom-layout="scroll"
              :auto-size-cell="true"
              :columns="paramColumns"
              :rows="paramRows"
              class="agGrid"
              @doubleClicked="insertTextAtCursor"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button class="btn primary small" @click="onAddTemplate">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import bus from '@/utils/bus'
import { CellRenderCheckbox } from '@/utils/cellRenders.js'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
// import Tinymce from '@/components/Tinymce'
// import ConfigModelSearch from '../components/configModelSearch.vue'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckbox
    // ConfigModelSearch
    // Tinymce
  },
  data() {
    return {
      searchParams: {
        pageSize: 20,
        pageNum: 1,
        templateGroup: null,
        templateType: null
      },
      templateGroups: [],
      typeGroups: [],
      value: null,
      editorConfig: {
        // extraPlugins: 'pagebreak'
        // The configuration of the editor.
      },
      editor: ClassicEditor,
      editorData:
        '<p>Content of the editor 0.</p><div>Content of the editor 1.</div><div>Content of the editor 2.</div>',
      width: 0,
      context: null,
      dialogVisible: false,
      options: [
        {
          value: '1',
          label: 'Bảng Group/ Group Master Search'
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        },
        {
          value: 'Option4',
          label: 'Option4'
        },
        {
          value: 'Option5',
          label: 'Option5'
        }
      ],
      columns: [
        {
          headerName: 'Ưu tiên',
          field: 'priority',
          width: 70,
          maxWidth: 70,
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center'
        },
        {
          headerName: 'Tên mẫu',
          field: 'name',
          tooltipField: 'name'
        },
        {
          headerName: 'Áp dụng',
          cellRenderer: 'CellRenderCheckbox',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          field: 'apply',
          width: 100,
          maxWidth: 100
        }
      ],
      rows: [],
      // data for pop-up
      data: {
        name: 'test template 1',
        layout: 1,
        paper_size_id: 60,
        content: 'abc',
        template_group: null,
        template_type: null
      },
      layoutList: [
        {
          label: 'Dọc',
          value: 0
        },
        {
          label: 'Ngang',
          value: 1
        }
      ],
      typeList: [
        {
          name: 'Thông tin khách sạn',
          value: 1
        },
        {
          name: 'Bảng dịch vụ đặc biệt',
          value: 2
        }
      ],
      paperSizeList: [],
      paramColumns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        // },
        {
          headerName: 'Mã',
          field: 'id',
          width: 80,
          maxWidth: 80
        },
        {
          headerName: 'Tên tham số',
          field: 'name',
          tooltipField: 'name',
          width: 150
        },
        {
          headerName: 'Mô tả',
          field: 'description',
          cellRenderer: params => {
            return params.data.description
          },
          wrapText: true,
          autoHeight: true
        }
      ],
      paramRows: [
        {
          code: '1',
          name: 'Hotel Address',
          desc: 'Thông tin khách sạn',
          isFullWidthRow: true
        },
        {
          code: '1',
          name: 'HotelAddress',
          desc: 'Khách sạn - Địa chỉ'
        },
        {
          code: '2',
          name: 'HotelEmail',
          desc: 'Khách sạn - Email'
        },
        {
          code: '3',
          name: 'HotelFax',
          desc: 'Khách sạn - Số Fax'
        },
        {
          code: '1',
          name: 'Hotel Address',
          desc: 'Bảng dịch vụ đặc biệt',
          isFullWidthRow: true
        },
        {
          code: '69',
          name: 'ListSpecialService',
          desc: 'Bảng <br/> dịch <br/> vụ'
        },
        {
          code: '70',
          name: 'SpecialServiceSubAmount',
          desc: 'Bảng dịch vụ đặc biệt - Tổng tiền trước bảng'
        },
        {
          code: '71',
          name: 'SpecialServiceSubAmount_USD',
          desc: 'Bảng dịch vụ đặc biệt - Tổng tiền ở đâu đấyTổng tiền ở đâu đấyTổng tiền ở đâu đấy'
        }
      ]
    }
  },
  watch: {
    editorData() {
      if (this.editorData.includes('abcd')) {
        console.log('watch: ', this.editorData)
      }
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  created() {
    this.getTemplateGroupList()
  },
  mounted() {
    document.addEventListener('keyup', event => {
      console.log('treck event: ', event)
    })
    this.getPaperSizeList()
    this.getListParameter()
  },
  methods: {
    // insertText() {
    //   // if (this.editor) {
    //   const textToInsert = 'Text to insert'
    //   this.editor.insertContent(textToInsert)
    //   // }
    // },
    onEditorReady(editor) {
      this.editorInstance = editor
    },
    insertTextAtCursor() {
      const insertData = this.$refs.agGrid2.gridApi.getSelectedRows()[0].id
      const arr =
        this.editorInstance.model.document.selection.getFirstPosition()
      const doc = new DOMParser().parseFromString(this.editorData, 'text/html')
      const rowArray = [...doc.body.children].map(el => el.outerHTML)
      var cursorY =
        this.editorInstance.model.document.selection.getFirstPosition().path[0]
      if (arr.path.length > 2) {
        var tableY =
          this.editorInstance.model.document.selection.getFirstPosition()
            .path[1]
        var tableX =
          this.editorInstance.model.document.selection.getFirstPosition()
            .path[2]
        var tableCursor =
          this.editorInstance.model.document.selection.getFirstPosition()
            .path[4]
      } else {
        var cursorX =
          this.editorInstance.model.document.selection.getFirstPosition()
            .path[1]
      }
      if (arr.path.length > 2) {
        let tableString = rowArray[cursorY]
        const tableSplited = tableString.split('<tr>')
        const tableRow = tableSplited[tableY + 1]
        const tableRowSplited = tableRow.split('<td>')
        const tableCell = tableRowSplited[tableX + 1]
        const newCellData =
          tableCell.slice(0, tableCursor) +
          `{{${insertData}}}` +
          tableCell.slice(tableCursor, tableCell.length)
        tableRowSplited[tableX + 1] = newCellData
        const tableRowJoined = tableRowSplited.join('<td>')
        tableSplited[tableY + 1] = tableRowJoined
        tableString = tableSplited.join('<tr>')
        rowArray[cursorY] = tableString
        this.editorData = rowArray.join('')
        return
      } else {
        const rowData =
          this.editorInstance.model.document.selection.getFirstPosition().root
            ._children._nodes[cursorY]._children._nodes[0]._data
        const newRowData =
          rowData.slice(0, cursorX) +
          `{{${insertData}}}` +
          rowData.slice(cursorX, rowData.length)
        rowArray[cursorY] = newRowData
        this.editorData = rowArray.join('')
      }
    },
    onRowClicked(params) {
      document.querySelector('#template-render-section').innerHTML =
        params[0].content
    },
    deleteTemplate() {
      this.$confirm('Bạn chắc chắn muốn xoá loại tiền tệ này?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const gridApi = this.$refs.agGrid.gridApi
        const idList = []
        idList.push(gridApi.getSelectedRows()[0].id)
        this.$axios
          .delete('/config-service/v1/template', {
            data: { id_list: idList }
          })
          .then(res => {
            this.$message({
              type: 'success',
              message: 'Xóa thành công'
            })
            // this.
          })
      })
    },
    onUpTemplate() {
      const gridApi = this.$refs.agGrid.gridApi
      const id = gridApi.getSelectedRows()[0].id
      this.$axios
        .put(`/config-service/v1/template/template-config/up/${id}`, {
          params: { id: id }
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Cập nhật thông tin thành công'
          })
          this.attachData()
        })
    },
    onDownTemplate() {
      const gridApi = this.$refs.agGrid.gridApi
      const id = gridApi.getSelectedRows()[0].id
      this.$axios
        .put(`/config-service/v1/template/template-config/down/${id}`, {
          params: { id: id }
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Cập nhật thông tin thành công'
          })
          this.attachData()
        })
    },
    async attachData() {
      bus.$emit('startLoader', { msg: '' })
      await this.$axios
        .get('/config-service/v1/template/template-config', {
          params: {
            templateGroup: this.data.template_group,
            templateType: this.data.template_type,
            pageNum: 1,
            pageSize: 50
          }
        })
        .then(res => {
          this.rows = res.data
        })
        .finally(() => {
          bus.$emit('endLoader')
        })
    },
    async onSearch(params) {
      this.data.template_group = params.templateGroup
      this.data.template_type = params.templateType
      await this.attachData()
      setTimeout(() => {
        const evt = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true,
          clientX: 20
        })
        const ele = document.querySelector('.ag-row-first')
        ele.dispatchEvent(evt)
      }, 200)
    },
    addModel() {
      // this.$router.push('/configuration/configuration/model/add')
      this.dialogVisible = true
      setTimeout(() => {
        this.width = document.getElementById('left').offsetWidth
        window.addEventListener('resize', () => {
          this.width = document.getElementById('left').offsetWidth
        })
      }, 200)
      // Tinymce.init({
      //   selector: '#myTextarea',
      //   setup: (editor) => {
      //     this.editor = editor
      //   }
      // })
    },
    modifyModel() {
      this.$router.push('/configuration/configuration/model/modify')
    },
    getHotelList(params) {},
    // pop-up methods
    onAddTemplate() {
      this.$axios
        .post('/config-service/v1/template/template-config', this.data)
        .then(res => {
          this.$message({
            message: 'Thêm thành công',
            type: 'success'
          })
          this.attachData()
          this.dialogVisible = false
        })
    },
    getPaperSizeList() {
      this.$axios
        .get('/config-service/v1/statistic/code/code-base', {
          params: {
            pCode: 'PAPERSIZE'
          }
        })
        .then(res => {
          this.paperSizeList = res.data
        })
    },
    getListParameter() {
      this.$axios.get('/config-service/v1/template/parameter').then(res => {
        this.paramRows = res.data.map(item => {
          if (item.parameter_type_name) {
            return {
              ...item,
              isFullWidthRow: true,
              name: item.parameter_type_name
            }
          } else {
            return item
          }
        })
        // paramRows
      })
    },
    async getTemplateGroupList() {
      this.$axios
        .get('/config-service/v1/statistic/code/code-base', {
          params: {
            pCode: 'TEMPLATEGROUP'
          }
        })
        .then(async res => {
          this.templateGroups = res.data
          this.searchParams.templateGroup = this.templateGroups[0].id
          await this.getTemplateTypeList(this.templateGroups[0].code)
          this.onSearch(this.searchParams)
        })
    },
    changeTemplateGroup(data) {
      const ele = this.templateGroups.find(
        item => item.id === data.templateGroup
      )
      this.getTemplateTypeList(ele.code)
    },
    async getTemplateTypeList(code) {
      await this.$axios
        .get('/config-service/v1/statistic/code/code-base', {
          params: {
            pCode: code
          }
        })
        .then(res => {
          this.typeGroups = res.data
          this.searchParams.templateType = this.typeGroups[0].id
        })
    }
  }
}
</script>

<style lang="scss">
.table-container {
  margin: 10px 0;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  td,
  th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }
}

input,
textarea {
  border: none;
  width: 100%;

  &:focus {
    outline: none;
  }
}

.bg-white {
  background: white;
}

#template-render-container {
  padding: 10px 150px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 70vh;
  background: #f0f0f5;
  // border: 1px solid #ced4da;
}

#template-render-section {
  overflow: hidden;
  padding: 30px;
  box-sizing: border-box;
  // border: 1px solid red;
  // box-shadow: rgba(0, 0, 0, 0.36) 0px 4px 8px 1px;
}
</style>
